import React from 'react';
import { SlideToggle } from '@bryntum/schedulerpro';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumSlideToggle extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        const className = `b-react-${BryntumSlideToggle.instanceClass.$name.toLowerCase()}-container`;
        return (React.createElement("div", { className: className, ref: (element) => (this.element = element) }));
    }
}
BryntumSlideToggle.instanceClass = SlideToggle;
BryntumSlideToggle.instanceName = 'SlideToggle';
BryntumSlideToggle.configNames = [
    'adopt',
    'align',
    'anchor',
    'ariaDescription',
    'ariaLabel',
    'autoCollapse',
    'autoComplete',
    'autoSelect',
    'bubbleEvents',
    'callOnFunctions',
    'centered',
    'checkedValue',
    'clearable',
    'color',
    'config',
    'constrainTo',
    'container',
    'containValues',
    'contentElementCls',
    'defaultBindProperty',
    'dock',
    'draggable',
    'floating',
    'hideAnimation',
    'highlightExternalChange',
    'hint',
    'hintHtml',
    'htmlCls',
    'ignoreParentReadOnly',
    'inline',
    'inputAlign',
    'inputAttributes',
    'inputType',
    'inputWidth',
    'keyStrokeChangeDelay',
    'labelCls',
    'labelPosition',
    'labels',
    'labelWidth',
    'listeners',
    'localeClass',
    'localizable',
    'localizableProperties',
    'maskDefaults',
    'masked',
    'monitorResize',
    'owner',
    'placeholder',
    'positioned',
    'preventTooltipOnTouch',
    'relayStoreEvents',
    'required',
    'revertOnEscape',
    'ripple',
    'rootElement',
    'scrollAction',
    'showAnimation',
    'showTooltipWhenDisabled',
    'spellCheck',
    'tab',
    'tag',
    'text',
    'textAlign',
    'title',
    'ui',
    'uncheckedValue',
    'validateOnInput',
    'weight'
];
BryntumSlideToggle.propertyConfigNames = [
    'alignSelf',
    'appendTo',
    'badge',
    'checked',
    'cls',
    'content',
    'dataset',
    'disabled',
    'editable',
    'extraData',
    'flex',
    'height',
    'hidden',
    'html',
    'id',
    'insertBefore',
    'insertFirst',
    'label',
    'margin',
    'maxHeight',
    'maximizeOnMobile',
    'maxWidth',
    'minHeight',
    'minWidth',
    'name',
    'onAction',
    'onBeforeChange',
    'onBeforeDestroy',
    'onBeforeHide',
    'onBeforeShow',
    'onCatchAll',
    'onChange',
    'onClear',
    'onClick',
    'onDestroy',
    'onFocusIn',
    'onFocusOut',
    'onHide',
    'onInput',
    'onPaint',
    'onReadOnly',
    'onRecompose',
    'onResize',
    'onShow',
    'onTrigger',
    'readOnly',
    'scrollable',
    'tooltip',
    'triggers',
    'value',
    'width',
    'x',
    'y'
];
BryntumSlideToggle.propertyNames = [
    'anchorSize',
    'input',
    'type'
];
//# sourceMappingURL=BryntumSlideToggle.js.map